// Unpublished Work © 2020-2024 Deere & Company.

import React from 'react';
import PropTypes from 'Utils/prop-type-utils';
import {tileTitleTranslationKeys} from 'Ui/components/common/tile-constants/translations';
import {isAuthorized} from 'Common/utils/authorization-handler';
import homeTiles from 'Ui/components/common/tile-constants/tiles/home';
import {Checkbox, ListItem, ListItemButton, ListItemIcon, ListItemText} from '@deere/isg.component-library';

function TileCategory(props) {
    const {
        activeTiles,
        onChange,
        tiles,
        translations,
        userAuth
    } = props;

    return (
        <>
            {tiles.map(({
                id,
                name
            }) => {
                const labelId = `checkbox-list-label-${name}`;
                const checked = activeTiles[id] ?? false;
                const disabled = !isAuthorized(homeTiles[id], userAuth);

                return (
                    <ListItem
                        dense
                        key={id}
                    >
                        <ListItemButton>
                            <ListItemIcon>
                                <Checkbox
                                    checked={checked}
                                    disabled={disabled && !checked}
                                    id={id}
                                    onChange={onChange}
                                />
                            </ListItemIcon>
                            <ListItemText
                                id={labelId}
                                primary={translations[tileTitleTranslationKeys[name]].toLowerCase()}
                                sx={{
                                    textTransform: 'capitalize'
                                }}
                            />
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </>
    );
}

TileCategory.propTypes = {
    activeTiles: PropTypes.objectOfBool,
    initialActiveTiles: PropTypes.objectOfBool,
    onChange: PropTypes.func,
    tiles: PropTypes.arrayOf(PropTypes.tile),
    translations: PropTypes.translations,
    userAuth: PropTypes.object
};

export default TileCategory;
